import React from "react";

import { HashRouter as Router, Route, Routes } from "react-router-dom";

//user import
import { Login, Signup, ForgetPassword, ResetPassword } from "./pages";
import ThemeProvider from "./theme";
import Layout from "./layout";

import { MainRoutes, NAV_ROUTES } from "./Services/Routes/App";
import {
  PrivateRoute,
  PrivateRouteWrapper,
} from "./Services/Routes/App/PrivateRouts";

//component

function App() {
  return (
    <div id="app">
      <ThemeProvider>
        <Router>
          <Routes>
            <Route
              caseSensitive
              exact
              path={`/*`}
              element={
                <PrivateRouteWrapper>
                  <Layout />
                </PrivateRouteWrapper>
              }
            />
            <Route caseSensitive path={MainRoutes?.root} element={<Login />} />
            <Route
              caseSensitive
              path={MainRoutes?.signup}
              element={<Signup />}
            />

            <Route
              caseSensitive
              path={NAV_ROUTES?.forgot_Password}
              element={<ForgetPassword />}
            />
            <Route
              caseSensitive
              path={NAV_ROUTES?.set_Password}
              element={<ResetPassword />}
            />

            {/* <Route
              caseSensitive
              exact
              path={NAV_ROUTES?.signup}
              element={<Signup />}
            />
            <Route
              caseSensitive
              exact
              path={NAV_ROUTES?.transaction}
              element={<Transaction />}
            />
            <Route
              caseSensitive
              exact
              path={NAV_ROUTES?.notifications}
              element={<Notification />}
            /> */}
            {/* <Route
              caseSensitive
              exact
              path={NAV_ROUTES?.dashboard}
              element={<Dashboard />}
            /> */}
          </Routes>
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
